import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgReparatie = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 11.3137L11.3137 1.23978e-05L16.4049 5.09118L12.8693 8.62671L20.5061 16.2635L16.2635 20.5061L8.6267 12.8694L5.09117 16.4049L0 11.3137ZM2.68701 11.1723L5.23259 13.7179L8.76812 10.1823L16.4049 17.8191L17.8191 16.4049L10.1823 8.76814L13.7179 5.2326L11.1723 2.68702L2.68701 11.1723Z"
      fill="currentColor"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgReparatie);

export default ForwardRef;
